<template lang="pug">
span
  v-menu(v-model="showMenu" rounded="lg" allow-overflow attach :close-on-content-click="false" offset-y max-height="360" min-width="320" max-width="320" nudge-bottom="8")
    template(v-slot:activator="{ on, attrs }")
      v-btn.px-2.button-text-normal.button-filter.text-none(v-if="selectedUrgent !== null" outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(@click.stop="clear" size=13) $yzi-x-circle
        .text-xs.font-semibold {{ $t('urgency') }}
        .px-1.neutral400--text | 
        .text-xs.primary--text.font-medium {{ selectedUrgent ? $t('urgent') : $t('non_urgent') }}
        v-icon.ml-1(size=16) $yzi-chevron-down
      v-btn.px-2.button-text-normal.border-dashed.button-filter(v-else outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(size=13) $yzi-plus-circle
        .text-xs.text-none.font-semibold {{ $t('urgency') }}
    
    .white
      .font-semibold.text-sm.px-4.pt-4.pb-2 {{ $t('filter_by') }} {{ $t('urgency').toLowerCase() }}
      div
        .d-flex.text-sm.py-2.px-4
          yc-checkbox(v-model="isUrgent" @change="updateUrgent")
          .ml-4 {{ $t('urgent') }}
        v-divider.basic300
      .pb-2
        .d-flex.text-sm.py-2.px-4
          yc-checkbox(v-model="isNonUrgent" @change="updateNonUrgent")
          .ml-4 {{ $t('non_urgent') }}

    .bottom-0.sticky.z-1.white
      .d-flex.align-center.px-4.py-3.border-t
        .text-sm.font-semibold.underline.normal-case.neutral700--text.cursor-pointer(v-if="isUrgent || isNonUrgent" @click="clear") {{ $t('clear') }}
        v-spacer
        v-btn.button-sm(@click="apply" color="primary" depressed :disabled="isUrgent === null") {{ $t('apply') }}

</template>

<script>
export default {
  props: {
    filter: {
      type: Object,
      default: (() => {})
    },
    checkInitialValue: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showMenu: false,
    isUrgent: null,
    isNonUrgent: null,
    selectedUrgent: null,
  }),
  watch: {
    filter: {
      handler () {
        if (!this.filter.key) { this.clearData() }
      } 
    },
  },
  mounted () {
    this.setData()
  },
  methods: {
    setData () {
      if (this.checkInitialValue) {
        if (this.filter.key) {
          this.selectedUrgent = this.filter.value
          if (this.filter.value) {
            this.isUrgent = true
          } else {
            this.isNonUrgent = true
          }
        }
      }
    },
    updateUrgent (value) {
      this.isUrgent = value
      this.isNonUrgent = !value
    },
    updateNonUrgent (value) {
      this.isNonUrgent = value
      this.isUrgent = !value
    },
    clear () {
      this.clearData()
      this.$emit('update:filter', {})
    },
    clearData () {
      this.isUrgent = null
      this.isNonUrgent = null
      this.selectedUrgent = null
    },
    apply () {
      this.showMenu = false
      this.selectedUrgent = this.isUrgent
      let filter = { key: 'urgent', value: this.selectedUrgent }
      this.$emit('update:filter', filter)
    }
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}
</style>